import React from "react";
import { Link } from "react-router-dom";

/**
 * Footer permanent affiché en bas de toutes les pages (publiques et connectées).
 * Trois liens RGPD/CGU : Mentions légales · Politique de confidentialité · Contact.
 */
export function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 bg-[#0a0e1c] text-slate-400">
      <div className="mx-auto max-w-6xl px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs">
        <div data-testid="site-footer-copyright">
          © {new Date().getFullYear()} Blanc des Montagnes — Conciergerie
        </div>
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <Link data-testid="site-footer-legal-link" to="/mentions-legales" className="hover:text-slate-200 transition-colors">
            Mentions légales
          </Link>
          <span className="text-slate-600">·</span>
          <Link data-testid="site-footer-privacy-link" to="/politique-confidentialite" className="hover:text-slate-200 transition-colors">
            Politique de confidentialité
          </Link>
          <span className="text-slate-600">·</span>
          <a data-testid="site-footer-contact-link" href="mailto:info@blancdesmontagnes.com" className="hover:text-slate-200 transition-colors">
            Contact
          </a>
        </nav>
      </div>
    </footer>
  );
}

export default SiteFooter;
